module.exports = __webpack_public_path__ + "static/media/proyecciones_icon.46426328.svg";